var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styleMain},[_c('el-button',{attrs:{"plain":!_vm.active,"type":"primary","size":"mini","icon":_vm.icon},on:{"click":function($event){return _vm.$emit('update')}}},[_vm._v(_vm._s(_vm.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }